import {
  getCancellationReasonMessage,
  getOrderProgressSummary,
} from "@/lib/order-status"
import { OrderResponse } from "@/types/external"
import { useState } from "react"
import OrderProgressBar from "./OrderProgressBar"
import OrderTimelineModal from "./OrderTimelineModal"
import { Button, Card, Divider, Text } from "@/components/ui";

const StatusOrderClient = ({
  order,
  canResumePix = false,
  onShowQr,
}: {
  order: OrderResponse
  canResumePix?: boolean
  onShowQr?: () => void
}) => {
  const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false)

  const { label, progress, progressTone, arrivalLabel } = getOrderProgressSummary(order)
  const cancellationReason = getCancellationReasonMessage(order)
  const arrivalPrefix =
    order.type === "DELIVERY" || order.type === "INDOOR"
      ? "Previsão de entrega:"
      : "Previsão de retirada:"

  return (
    <>
      <Card interactive padding="lg" className="relative">
        <div className="flex flex-col gap-2">
          <Text as="span" size="lg" weight="bold" tone="default">
            {label}
          </Text>
          {cancellationReason && (
            <Text size="sm" tone="danger">
              {cancellationReason}
            </Text>
          )}
          <OrderProgressBar progress={progress} progressTone={progressTone} className="my-2" />
          <div className="flex items-center justify-between">
            <Text as="span" size="sm" tone="muted">
              {arrivalPrefix}
            </Text>
            <Text as="span" size="sm" weight="bold" tone="default">
              {arrivalLabel}
            </Text>
          </div>
          <Button
            variant="link"
            tone="neutral"
            size="auto"
            aria-haspopup="dialog"
            onClick={() => setIsTimelineModalOpen(true)}
            className="mt-2 self-center no-underline after:absolute after:inset-0"
          >
            <Text as="span" size="xs" weight="normal">
              Toque para ver detalhes do acompanhamento
            </Text>
          </Button>

          {canResumePix && onShowQr && (
            <div className="relative flex flex-col gap-3">
              <Divider />
              <Button type="button" onClick={onShowQr} fullWidth>
                Exibir QR Code
              </Button>
            </div>
          )}
        </div>
      </Card>

      <OrderTimelineModal
        order={order}
        open={isTimelineModalOpen}
        onOpenChange={setIsTimelineModalOpen}
        canResumePix={canResumePix}
        onShowQr={onShowQr}
      />
    </>
  )
}

export default StatusOrderClient
